var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('span',{staticClass:"text-caption mb-1 d-block"},[_vm._v(_vm._s(_vm.loadingMessage))]),_c('v-progress-linear',{attrs:{"color":"secondary","indeterminate":"","rounded":"","height":"8"}})]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }